import type { ExperienceItem } from "./types";

export const experience: ExperienceItem[] = [
    {
        id: "accordance-2025",
        organization: "Accordance",
        title: "Member of Technical Staff",
        date: "September 2025 – Present",
        description: [
            "Developed the billing infrastructure 0 to 1, creating Stripe and Zoho CRM integrations, permission-based access control, and automatic invoicing, processing over $100K in transactions and supporting over 2K users.",
            "Architected an agentic pipeline that automates tax exemption certificate review, checking them against the governing state form's requirements, underlying transaction, and producing binary determination with a corresponding defense memo.",
            "Engineered the internal admin platform that oversees user management, billing, usage dashboards, and a CRM-backed view of customer engagements.",
            "Built developer infrastructure around the internal admin platform,  including per-PR preview environments on Kubernetes and containerized benchmark runners",
            "Created an agentic Word document integration that lets the agent read, edit, and create documents directly, along with a companion in-app editor and a PDF viewer that opens from citations, attachments, and file storage.",
        ],
    },
    {
        id: "amazon-2024",
        organization: "Amazon",
        title: "Software Development Engineering Intern",
        date: "June 2024 – September 2024",
        description: [
            "Spearheaded development of a full-stack application that supports Amazon inspections of dangerous goods for over 10,000 packages daily, increasing operational efficiency, utilizing Kotlin, Java, TypeScript, and DynamoDB.",
            "Authored unit and integration tests covering API endpoints and front-end components using Jest, Jqwik, and React-testing, contributing to error-free deployments in multiple environments.",
            "Achieved 1st place at internal Amazon team hackathon, fine-tuned Flan-Base LLM using PyTorch and Hugging Face for a downstream classification task, competing against 30+ full-time engineers; given but declined full-time return offer.",
        ],
    },
    {
        id: "stanford-ml-2024",
        organization: "Stanford Machine Learning Group (Andrew Ng's Group)",
        title: "Research Intern",
        date: "Jan 2024 – June 2024",
        description: [
            "Advised by Andrew Ng to leverage Dinov2 and MAE self-supervised pre-training objectives for 3D medical imaging modalities",
            "Conducted downstream benchmarks for an organ classification task and 3D organ segmentation",
        ],
    },
    {
        id: "stanford-ta-2023",
        organization: "Stanford University",
        title: "CS 106a/b Teaching Assistant",
        date: "September 2023 – June 2024",
        description: [
            "Taught weekly lecture-style workshops on programming methodology to 10+ students in Python and C++.",
            "Hosted interactive grading sessions and office hours for topics such as recursive backtracking and data structures.",
            "Supported Stanford's two largest CS courses with roughly 1200 student enrollment.",
        ],
    },
    {
        id: "nasa-2023",
        organization: "NASA Ames Center",
        title: "Software Engineering Intern",
        date: "June 2023 – August 2023",
        description: [
            "Built a retrieval-augmented generative Q&A pipeline with Haystack to help engineers in preliminary design review and risk assessment of different NASA missions (foundation for potential usage from 100+ engineers).",
            "Integrated pipeline to internal full-stack app using ReactJS front-end with an ExpressJS & Gunicorn back-end.",
        ],
    },
    {
        id: "nasa-2021",
        organization: "NASA Ames Center",
        title: "Software Engineering Intern (Full-Stack)",
        date: "June 2021 – August 2021",
        description: [
            "Constructed an internal timeline web application, to visualize mission progress for various NASA teams.",
            "Implemented expandable event nodes with various different views, pulling events from internal RESTful APIs with an ExpressJS and MongoDB backend.",
        ],
    },
];
